var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-draggable",
      class: {
        coverDraggable: _vm.coverDraggable,
        coverSticker: _vm.coverSticker,
        draging: _vm.dragOptions.down,
        selectDisable: _vm.dragOptions.down,
        [_vm.classCustom]: true,
      },
      style: {
        top: `${_vm.dragOptions.down ? _vm.dragOptions.y : _vm.position.y}%`,
        left: `${_vm.dragOptions.down ? _vm.dragOptions.x : _vm.position.x}%`,
        zIndex: _vm.zIndex,
        transform: `
            translate(-50%, -50%)
            scale(${
              _vm.isSelected
                ? 1
                : _vm.resizeOptions.down
                ? _vm.resizeOptions.scale
                : _vm.transform.scale
            })
            rotate(${
              _vm.isSelected
                ? 0
                : _vm.rotateOptions.down
                ? _vm.rotateOptions.rotate
                : _vm.transform.rotate
            }deg)
            `,
      },
      on: { mousedown: _vm.startDrag },
    },
    [
      !_vm.disableTransform
        ? _c(
            "div",
            {
              class: `corner corner-rotate edge-top edge-left rotate-cursor-${
                ((_vm.indexImageCursor + (8 % 24) + 24) % 24) + 1
              }`,
              attrs: { cornerIndex: "0" },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                  return _vm.startRotate.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                class: `corner corner-resize edge-bottom edge-right resize-cursor-${
                  ((_vm.indexImageCursor + (8 % 12) + 12) % 12) + 1
                }`,
                attrs: { cornerIndex: "0" },
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    return _vm.startResize.apply(null, arguments)
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      !_vm.disableTransform
        ? _c(
            "div",
            {
              class: `corner corner-rotate edge-top edge-right rotate-cursor-${
                ((_vm.indexImageCursor + (14 % 24) + 24) % 24) + 1
              }`,
              attrs: { cornerIndex: "1" },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                  return _vm.startRotate.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                class: `corner corner-resize edge-bottom edge-left resize-cursor-${
                  ((_vm.indexImageCursor + (14 % 12) + 12) % 12) + 1
                }`,
                attrs: { cornerIndex: "1" },
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    return _vm.startResize.apply(null, arguments)
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      !_vm.disableTransform
        ? _c(
            "div",
            {
              class: `corner corner-rotate edge-bottom edge-right rotate-cursor-${
                ((_vm.indexImageCursor + (20 % 24) + 24) % 24) + 1
              }`,
              attrs: { cornerIndex: "2" },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                  return _vm.startRotate.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                class: `corner corner-resize edge-top edge-left resize-cursor-${
                  ((_vm.indexImageCursor + (20 % 12) + 12) % 12) + 1
                }`,
                attrs: { cornerIndex: "2" },
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    return _vm.startResize.apply(null, arguments)
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      !_vm.disableTransform
        ? _c(
            "div",
            {
              class: `corner corner-rotate edge-bottom edge-left rotate-cursor-${
                ((_vm.indexImageCursor + (2 % 24) + 24) % 24) + 1
              }`,
              attrs: { cornerIndex: "3" },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                  return _vm.startRotate.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                class: `corner corner-resize edge-top edge-right resize-cursor-${
                  ((_vm.indexImageCursor + (2 % 12) + 12) % 12) + 1
                }`,
                attrs: { cornerIndex: "3" },
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    return _vm.startResize.apply(null, arguments)
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.rotateOptions.down && Math.abs(_vm.rotateOptions.rotate % 45) == 0
        ? _c("div", {
            staticClass: "axe axeX",
            style: {
              transform: `
            translate(-50%, -50%)
            scale(${
              1 /
              (_vm.isSelected
                ? 1
                : _vm.resizeOptions.down
                ? _vm.resizeOptions.scale
                : _vm.transform.scale)
            }) 
            `,
            },
          })
        : _vm._e(),
      _vm._t("default", null, {
        setCbClick: _vm.setCbClick,
        isPreventCover: _vm.isSelected,
        isCover: _vm.isSelected,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }